const ZERO_DECIMAL_CURRENCIES = new Set([
	'bif', // Burundian Franc
	'clp', // Chilean Peso
	'djf', // Djiboutian Franc
	'gnf', // Guinean Franc
	'jpy', // Japanese Yen
	'kmf', // Comorian Franc
	'krw', // South Korean Won
	'mga', // Malagasy Ariary
	'pyg', // Paraguayan Guaraní
	'rwf', // Rwandan Franc
	'vnd', // Vietnamese Đồng
	'vuv', // Vanuatu Vatu
	'xaf', // Central African Cfa Franc
	'xof', // West African Cfa Franc
	'xpf', // Cfp Franc
]);

const THREE_DECIMAL_CURRENCIES = new Set([
	'bhd', // Bahraini Dinar
	'jod', // Jordanian Dinar
	'kwd', // Kuwaiti Dinar
	'lyd', // Libyan Dinar
	'omr', // Omani Rial
	'tnd', // Tunisian Dinar
	// IQD (Iraqi Dinar) is intentionally absent: ISO 4217 says 3 but ICU formats it with 0 fraction digits. Until we
	// confirm how the backend stores it, it keeps the default exponent of 2.
]);

/**
 * Number of decimal places between a currency's whole unit and its base (minor) unit,
 * i.e. base units = amount * 10 ** exponent.
 *
 * Kept as an explicit map rather than derived from `Intl`, whose fraction digits differ from ISO 4217 for some currencies.
 */
export function getCurrencyMinorUnitExponent(currency: string): 0 | 2 | 3 {
	const code = currency.toLowerCase();
	if (ZERO_DECIMAL_CURRENCIES.has(code)) {
		return 0;
	}
	if (THREE_DECIMAL_CURRENCIES.has(code)) {
		return 3;
	}
	return 2;
}
